export default "__VITE_ASSET__IL3$7eQm__"